import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';

import { Box, Tooltip } from '@mui/material';

import { severitiesList } from '../../../../../services/Form';

const styles = ({ severityItem }) => ({
  minWidth: '20px',
  width: '20px',
  height: '20px',
  borderRadius: '500px',
  background: severityItem?.color,
  marginRight: '20px',
});

export const SeverityIcon = memo(({ severity }) => {
  const severityItem = severitiesList.find((el) => el.value === severity);

  return (
    <Tooltip title={t(severityItem?.name)}>
      <Box sx={styles({ severityItem })} />
    </Tooltip>
  );
});

SeverityIcon.propTypes = {
  severity: PropTypes.string,
};
